let blocks = [],
    offset = 0.075,
    height = 0,
    ticking = false,
    raf = window.requestAnimationFrame;

export function init() {
    blocks = document.querySelectorAll('.js-work-index-block');

    setupEvents();
    updateScroll();
}

function getOffsetHeight() {
    if (offset && typeof offset === 'number') {
        const fraction = Math.min(Math.max(0, offset), 1);
        return height - fraction * height;
    }

    return height;
}

function updateHeight() {
    const cH = document.documentElement.clientHeight;
    const wH = window.innerHeight || 0;
    height = Math.max(cH, wH);
}

function updateScroll() {
    ticking = false;
    const targetFromTop = getOffsetHeight();

    const elements = [...blocks].filter(el => {
        const { top, bottom, height } = el.getBoundingClientRect();
        const entered = top < targetFromTop;

        if (entered) {
            if (el.ev_entered) {
                return false;
            } else {
                el.ev_entered = true;
                
                // Only run once
                return true;
            }
        }
    });

    // Run in view logic on these blocks
    elements.forEach((el, i) => {
        setTimeout(function () {
            el.classList.add('work-block-in-view');
        }, i * 300);
    });

    if (!blocks.length) {
        window.removeEventListener('scroll', onScroll, true);
        window.removeEventListener('resize', onResize, true);
        window.removeEventListener('load', onLoad, true);
    }
}

function onScroll() {
    if (!ticking) {
        ticking = true;
        raf(updateScroll);
    }
}

function onResize() {
    updateHeight();
    updateScroll();
}

function onLoad() {
    updateHeight();
    updateScroll();
}

function setupEvents() {
    window.addEventListener('resize', onResize, true);
    window.addEventListener('scroll', onScroll, true);
    window.addEventListener('load', onLoad, true);
    onResize();
}